// extracted by mini-css-extract-plugin
module.exports = {"BenefitsMessage":"BenefitsMessage_BenefitsMessage__fQuJq","BenefitsModal":"BenefitsMessage_BenefitsModal__s98nF"};